<ng-container *ngIf="vm$ | async as vm">
  <div class="guts-p-h-1">
    <!-- Loading -->
    <section *ngIf="vm.isPageLoading" class="guts-p-b-2">
      <dgx-skeleton type="breadcrumb"></dgx-skeleton>
      <div class="guts-p-t-4 m-guts-m-h-1">
        <dgx-skeleton
          type="signalPageHeader"
          [isMobile]="vm.isMobile"
        ></dgx-skeleton>
      </div>
    </section>

    <section *ngIf="!vm.isPageLoading" class="guts-m-b-3">
      <div>
        <dgx-breadcrumbs
          [breadcrumbs]="vm.pageBreadcrumbs"
          class="'guts-p-l-3"
        ></dgx-breadcrumbs>
        <div class="guts-p-t-3">
          <div class="signals-header">
            <div class="l_flex guts-p-v-1 m-guts-p-v-0 m-l_flex">
              <dgx-profile-pic
                [profile]="vm.owner"
                class="guts-p-r-1"
              ></dgx-profile-pic>
              <h3 class="par par--small par--light_a l_flex-center">
                {{ vm.owner.name }}
              </h3>
            </div>
            <div
              class="
                l_flex
                m-l_flex
                l_flex-align-center
                guts-p-t-1 guts-p-b-3 guts-p-h-0
              "
            >
              <div
                class="
                  l_flex
                  m-l_flex
                  full-width
                  l_flex-center-children
                  grid--wrap
                "
              >
                <h1 class="h1 break guts-p-r-1">{{ vm.tag.name }}</h1>
                <dgx-signal-popover
                  [signalCount]="vm.signalCount.count"
                  [signalSummary]="vm.signalBreakdown[0]?.signals"
                ></dgx-signal-popover>
              </div>
              <div class="l_flex m-l_flex options_container">
                <dgx-skill-signal-share-button
                  [tagId]="tagId"
                  [ownerProfile]="vm.owner"
                ></dgx-skill-signal-share-button>
                <dgx-skill-signal-more-button
                  *ngIf="!!vm.isLoggedIn"
                  [tag]="vm.tag"
                  [isLoggedIn]="vm.isLoggedIn"
                  [ownerIsViewing]="vm.ownerIsViewing"
                ></dgx-skill-signal-more-button>
              </div>
            </div>
          </div>
          <dgx-tab-navigation-routerless
            [tabList]="tabList"
            wrapperClasses="guts-p-l-0"
            (updateSelectedTab)="switchTab($event)"
          >
          </dgx-tab-navigation-routerless>
        </div>
      </div>
    </section>

    <dgx-skill-signal-activity-chart
      *ngIf="!vm.isPageLoading"
      [signalsCount]="vm.chartSignals.signalCounts"
      [signalType]="vm.signalType"
      [isMobile]="vm.isMobile"
    ></dgx-skill-signal-activity-chart>
    <div *ngIf="vm.isPageLoading">
      <dgx-skeleton type="barChart" [isMobile]="vm.isMobile"></dgx-skeleton>
    </div>
    <div *ngIf="['All', 'Ratings'].includes(vm.signalType)" class="guts-p-t-2">
      <dgx-skill-signal-ratings
        class="skill-signal-ratings--condensed"
        [isLoading]="vm.isPageLoading"
        [tag]="vm.tag"
        [ratingDetails]="vm.ratingDetails"
        [isTagEvaluable]="vm.isTagEvaluable"
        [availableRatings]="vm.availableRatings"
        [allCheckpoints]="vm.allCheckpoints"
        [ownerIsViewing]="vm.ownerIsViewing"
        [isMobile]="vm.isMobile"
        [signalType]="vm.signalType"
      ></dgx-skill-signal-ratings>
    </div>
    <ng-container *ngIf="experiencesList$ | async as experiences">
      <div
        *ngIf="['All', 'Experiences'].includes(vm.signalType)"
        class="guts-p-b-1 guts-m-t-1"
        [class.guts-m-t-2]="vm.signalType === 'Experiences'"
      >
        <dgx-profile-experiences-v2
          [experiences]="experiences"
          [isPageLoading]="vm.isPageLoading"
          [profileName]="vm.owner.vanityUrl"
          [isRestrictedView]="true"
          [ownerIsViewing]="vm.ownerIsViewing"
          class="guts-m-b-1"
          [useShowMore]="true"
          [pageType]="vm.signalType"
          [useLoadingTemplate]="true"
          (loadMoreExperiences)="vm.loadExperiences()"
        >
        </dgx-profile-experiences-v2>
      </div>
    </ng-container>

    <ng-container *ngIf="achievementsList$ | async as achievements">
      <div
        *ngIf="['All', 'Achievements'].includes(vm.signalType)"
        class="guts-p-b-1 guts-m-t-2"
      >
        <dgx-profile-overview-achievements-v2
          [achievements]="achievements"
          [isPageLoading]="vm.isPageLoading"
          [profile]="vm.owner"
          [ownerIsViewing]="vm.ownerIsViewing"
          [isRestrictedView]="true"
          [achievementDisplayLimit]="vm.signalType === 'All' ? 8 : 12"
          [useCarousel]="false"
          [useShowMore]="vm.signalType === 'All'"
          [useLoadingTemplate]="true"
          [pageType]="vm.signalType"
          class="guts-m-b-1"
          [isMobile]="vm.isMobile"
          [cardRowLimit]="4"
          (loadMoreAchievements)="vm.loadAchievements()"
        >
        </dgx-profile-overview-achievements-v2>
      </div>
    </ng-container>

    <ng-container *ngIf="learningsList$ | async as learnings">
      <div
        *ngIf="['All', 'Learnings'].includes(vm.signalType)"
        class="guts-p-b-1 guts-m-t-half"
        [class.guts-m-t-2]="vm.signalType === 'Learnings'"
      >
        <dgx-profile-learning-v2
          [learnings]="learnings"
          [isPageLoading]="vm.isPageLoading"
          [profileName]="vm.owner.vanityUrl"
          [ownerIsViewing]="vm.ownerIsViewing"
          [isRestrictedView]="true"
          [learningDisplayLimit]="vm.signalType === 'All' ? 8 : 24"
          [useCarousel]="false"
          [pageType]="vm.signalType"
          [useShowMore]="vm.signalType === 'All'"
          [useLoadingTemplate]="true"
          [isMobile]="vm.isMobile"
          [cardRowLimit]="4"
          (loadMoreLearnings)="vm.loadLearnings()"
        >
        </dgx-profile-learning-v2>
      </div>
    </ng-container>

    <!-- Footer -->
    <dgx-footer-glasses></dgx-footer-glasses>
  </div>
</ng-container>
